import { Zap } from "lucide-react";
import { isOpenNow } from "../lib/openingHours";

// Badge FOMO temps réel affiché sur les cards restaurant :
//   • Rendu SEULEMENT si le resto est ouvert MAINTENANT (isOpenNow=true)
//     ET livre en <= 30 min (delivery_eta_min).
//   • Sinon → null (aucun bruit visuel).
// Design volontairement voyant (fond vert éclair + pulse) pour créer un effet
// "prends-moi tout de suite" côté mobile. La keyframe `openFastPulse` est
// définie dans App.css (classe `open-fast-pulse`).
export default function OpenFastBadge({ resto, className = "" }) {
  const eta = typeof resto?.delivery_eta_min === "number" ? resto.delivery_eta_min : null;
  const open = isOpenNow(resto?.opening_hours_text);
  if (open !== true) return null;
  if (eta !== null && eta > 30) return null;

  const label = eta !== null ? `Ouvert · ${eta} min` : "Ouvert maintenant";
  return (
    <div
      data-testid={`resto-open-fast-${resto?.id || ""}`}
      className={`open-fast-pulse inline-flex items-center gap-1 rounded-full bg-[#059669] text-white px-2.5 py-1 text-[10px] font-black uppercase tracking-widest shadow-lg ring-2 ring-white/60 ${className}`}
    >
      <Zap className="w-3 h-3 fill-white" /> {label}
    </div>
  );
}
